export const WELCOME_BACKGROUND_SRC: string = 'https://res.cloudinary.com/carbonclick/image/upload/f_auto/v1687353050/Shopify%20V2/welcome_axp2eu.png';

export const ONBOARDING_BACKGROUND_SRC: string = 'https://res.cloudinary.com/carbonclick/image/upload/f_auto/v1687345748/Shopify%20V2/onboarding-background_syw2x6.png';
